import Joi from 'joi';
export const BASIC_DETAILS_FORM_KEYS = {
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    MAILING_ADDRESS: 'mailing_address',
    PERSONAL_EMAIL_ADDRESS: 'personal_email_address',
    EMERGENCY_NUMBER: 'emergency_number',
    PERSONAL_PHONE_NUMBER: 'personal_phone_number',
    PERSONAL_PHONE_CODE: 'personal_phone_code',
    ZIP_CODE: 'zip_code',
    COUNTRY_CODE : 'subDivisionCode',
    SUBDIVISION_NAME : 'subDivision',
    SUBDIVISION_CATEGORY: 'subDivisionCategory',
    CITY_NAME: 'city_name',

}


export const basicDetailsUsaFormSchema = Joi.object({
    [BASIC_DETAILS_FORM_KEYS.FIRST_NAME]: Joi.string().label('First Name').max(200).required().trim().regex(/^[a-zA-Z\s]*$/).messages({
        "string.pattern.base": "\"First Name\" is required with only alphabets"
    }),
    [BASIC_DETAILS_FORM_KEYS.LAST_NAME]: Joi.string().label('Last Name').max(200).required().trim().regex(/^[a-zA-Z\s]*$/).messages({
        "string.pattern.base": "\"Last Name\" is required with only alphabets"
    }),
    [BASIC_DETAILS_FORM_KEYS.MAILING_ADDRESS]: Joi.string().label('Mailing Address').max(500).required().messages({
        "string.base": "This is a \" required \" field"
    }),
    [BASIC_DETAILS_FORM_KEYS.PERSONAL_EMAIL_ADDRESS]: Joi.string().label('Email Address').max(500).required().messages({
        "string.base": "This is a \" required \" field"
    }),
    [BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_NUMBER]: Joi.number().label('Phone number').required().messages({
        "number.base": "\" Phone Number \" is a required field"
    }),
    [BASIC_DETAILS_FORM_KEYS.PERSONAL_PHONE_CODE]: Joi.string().label('Phone code').required().messages({
        "string.base": "\" Phone Code \" is a required field"
    }),
    [BASIC_DETAILS_FORM_KEYS.ZIP_CODE]: Joi.string().max(12).label('ZIP Code').required().messages({
        "string.base": "\" ZIP Code \" is a required field"
    }),
    [BASIC_DETAILS_FORM_KEYS.COUNTRY_CODE]: Joi.string().label('Country Code').required().messages({
        "string.base": "\" Country Code \" is a required field"
    }),
    [BASIC_DETAILS_FORM_KEYS.SUBDIVISION_NAME]: Joi.any().label('Sub Division Name').messages({
        "string.base": " Sub Division Name is a required field"
    }),
    [BASIC_DETAILS_FORM_KEYS.SUBDIVISION_CATEGORY]: Joi.any().label('Sub Division Category').messages({
        "string.base": " Sub Division Category is a required field"
    }),
    // [BASIC_DETAILS_FORM_KEYS.STATE_NAME]: Joi.string().max(100).label('State').required().messages({
    //     "string.base": "\" Sub division \" is a required field"
    // }),
    [BASIC_DETAILS_FORM_KEYS.CITY_NAME]: Joi.string().max(100).label('City').required().messages({
        "string.base": "\" city \" is a required field"
    })
})



export const customizeRadioButtonData = {
    "Male": {
        id: "M"
    },
    "Female": {
        id: "F"
    },
    "Others": {
        id: "O"
    },
    "Prefer not to say": {
        id: "P"
    }
}